<template>
  <div id="UpdateLogPopup">
    <popup ref="UpdateLogBox" type="center" :coverClose="false">
      <div class="UpdateLog">

        <div class="UpdateLog_title"> Runway中文站-更新公告</div>
        <div class="UpdateLog_tip">
          <p>
            由于 Runway Ai视频全新版本已经发布！我们正在进行系统升级，以便接入这一重要更新。
            <br><br>
            ⚠️升级期间可能出现：
            <br><br>
            ●&nbsp;视频生成暂时失败
            <br><br>
            ●&nbsp;服务短时间不稳定
            <br><br>🔔温馨提示：
            <br><br>●&nbsp;如遇生成失败，请稍后重试
            <br><br>●&nbsp;因故障影响的视频生成，可联系客服处理积分补偿
            <br><br>感谢理解和支持，我们将尽快完成升级，为您带来更优质的视频
          </p>
        </div>
        <div class="UpdateLog_btn">
          <div @click="close()">
            知道啦~
          </div>
        </div>
        <img class="rt_img" src="./img/notice-rt.png" alt="">
        <img class="lb_img" src="./img/notice-lb.png" alt="">
      </div>
    </popup>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"

export default {
  components: {popup},
  data() {
    return {

    }
  },
  methods: {
    show(name) {
      console.log(11111111)
      this.$refs.UpdateLogBox.show();
    },
    close(){
      this.$refs.UpdateLogBox.close();
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// 更新公告
.UpdateLog {
  width: 500px;
  //height: 500px;
  background: #303237;
  border-radius: 20px;
  position: relative;
  padding: 30px;
color: #FFF;
  .rt_img {
    position: absolute;
    top: -90px;
    right: -55px;

  }

  .lb_img {
    position: absolute;
    left: -35px;
    bottom: 0;
  }

  .UpdateLog_title {
    font-size: 24px;
    font-weight: 700;
    z-index: 5;
    position: relative;
  }

  .UpdateLog_tip {
    height: 300px;
    padding: 20px;
    margin-top: 24px;
    margin-bottom: 24px;
    border-radius: 4px;
    overflow-y: auto;
    border: 1px solid #FFF;
    white-space: normal;
    font-size: 14px;
  }

  .UpdateLog_btn {
    cursor: pointer;
  }

  .UpdateLog_btn div {
    font-size: 14px;
    margin: 0 auto;
    height: 40px;
    width: 150px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a202c;
    padding: 0 16px;
    background-color: #fbd38d;
    cursor: pointer;
    user-select: none;
  }
}
</style>